<div class="access-denied-header">
  <div>
    <h2 class="access-denied-header__title margin--yb-m">
      {{ 'AccessDenied.AccessDenied' | translate }}
    </h2>
    <h3 class="access-denied-header__sub-title margin--yb-m">
      <span class="material-icons">format_quote</span>
      {{ 'AccessDenied.ShallNotPass' | translate }}
      <span class="material-icons">format_quote</span>
    </h3>
    <div class="gandalf">
      <div class="fireball"></div>
      <div class="skirt"></div>
      <div class="sleeves"></div>
      <div class="torso">
        <div class="hand left"></div>
        <div class="hand right"></div>
      </div>
      <div class="head">
        <div class="hair"></div>
        <div class="helmet-top"></div>
        <div class="helmet-circle"></div>
        <div class="helmet-snap"></div>
        <div class="helmet-middle"></div>
        <div class="helmet-bottom"></div>
        <div class="helmet-stripe"></div>
        <div class="beard"></div>
      </div>
    </div>
    <div class="access-denied__text">
      <div class="access-denied__text__information">
        {{ 'AccessDenied.NotAllowed' | translate }}
      </div>
      <div class="access-denied__text__contact_admin">
        {{ 'AccessDenied.ContactAdmin' | translate }}
      </div>
    </div>
  </div>
</div>
